import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import TopLocations from "./components/TopLocations";
import Home from "./pages/Home";
import Login from "./pages/Login";
import Register from "./pages/Register";
import SignupWizard from "./pages/SignupWizard";
import ForgotPassword from "./pages/ForgotPassword";
import VerifyPhoneBanner from "./components/VerifyPhoneBanner";
import CategoryPage from "./pages/CategoryPage";
import ListingDetail from "./pages/ListingDetail";
import PostAd from "./pages/PostAd";
import Dashboard from "./pages/Dashboard";
import Membership from "./pages/Membership";
import Messages from "./pages/Messages";
import AdminSettings from "./pages/AdminSettings";
import UserProfile from "./pages/UserProfile";
import PaymentVerificationDashboard from "./pages/PaymentVerificationDashboard";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import StaffManagement from "./pages/StaffManagement";
import AdManagement from "./pages/AdManagement";
import CategoryManagement from "./pages/CategoryManagement";
import PaymentMethodSelection from "./pages/PaymentMethodSelection";
import BankTransferPayment from "./pages/BankTransferPayment";
import UploadPaymentProof from "./pages/UploadPaymentProof";
import PaymentStatus from "./pages/PaymentStatus";
import PaymentSuccess from "./pages/PaymentSuccess";
import PaymentRejected from "./pages/PaymentRejected";
import FeatureAdPurchase from "./pages/FeatureAdPurchase";
import AdminPaymentVerification from "./pages/AdminPaymentVerification";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import Disclaimer from "./pages/Disclaimer";
import TermsOfService from "./pages/TermsOfService";
import HelpCentre from "./pages/HelpCentre";
import AdminMembershipManagement from "./pages/AdminMembershipManagement";
import AdminMembershipPlans from "./pages/admin/AdminMembershipPlans";
import AdminLanguages from "./pages/admin/AdminLanguages";
import EditAd from "./pages/EditAd";
import Favorites from "./pages/Favorites";
import SearchResults from "./pages/SearchResults";
import MyOrders from "./pages/MyOrders";
import AdminIdentityVerification from "./pages/AdminIdentityVerification";
import AdminRolesManagement from "./pages/AdminRolesManagement";
import Admin2FASettings from "./pages/Admin2FASettings";
import IdentityVerification from "./pages/IdentityVerification";
import TwoFactorSetup from "./pages/TwoFactorSetup";
import AutoApprovalRules from "./pages/AutoApprovalRules";
import BannerAdsManagement from "./pages/BannerAdsManagement";
import AdAnalyticsDashboard from "./pages/AdAnalyticsDashboard";
import ChatPage from "./pages/ChatPage";
import UserAnalytics from "./pages/UserAnalytics";
import AIAdAssistant from "./pages/AIAdAssistant";
import AIMonitoringDashboard from "./pages/AIMonitoringDashboard";
import AdminAIControlCenter from "./pages/AdminAIControlCenter";
import ContentModerationQueue from "./pages/ContentModerationQueue";
import BoostOptimizer from "./pages/BoostOptimizer";
import BoostSuccess from "./pages/BoostSuccess";
import MembershipSuccess from "./pages/MembershipSuccess";
import VerificationPage from "./pages/VerificationPage";
import OTPAdminSettings from "./pages/OTPAdminSettings";
import SavedSearches from "./pages/SavedSearches";
import {
  AdminVehiclesDashboard, 
  VehicleConfigPage, 
  VehicleRankingPage,
  ListingsGovernancePage,
  ModerationQueuePage,
  DataEnrichmentPage,
  PartnersServicesPage,
  AIPresetsManagementPage,
  MakeModelManagementPage,
  ListingTabsManagementPage
} from "./pages/admin/vehicles";
import { FinanceAdminDashboard } from "./pages/admin/finance";
import { InsuranceAdminDashboard } from "./pages/admin/insurance";
import { MarketplaceDashboard } from "./pages/admin/marketplace";
import ServicesAdminDashboard from "./pages/admin/services/ServicesAdminDashboard";
import ServiceAnalyticsDashboard from "./pages/admin/ServiceAnalyticsDashboard";
import AdminBadgeAnalytics from "./pages/admin/AdminBadgeAnalytics";
import AdminITServices from "./pages/admin/AdminITServices";
import FeedbackPage from "./pages/FeedbackPage";
import DeliveryServicesPage from "./pages/DeliveryServicesPage";
import ServiceListingPage from "./pages/ServiceListingPage";
import { LenderRegister, LenderLogin, LenderDashboard } from "./pages/lender";
import { InsurerRegister, InsurerLogin, InsurerDashboard } from "./pages/insurer";
import { ProviderRegister, ProviderLogin, ProviderDashboard } from "./pages/provider";
import CoachRegister from "./pages/coach/CoachRegister";
import CoachDashboard from "./pages/coach/CoachDashboard";
import JobsPage from "./pages/JobsPage";
import EmployerDashboardAI from "./pages/EmployerDashboard";
import JobDetailPage from "./pages/JobDetailPage";
import { CandidateDashboard, EmployerDashboard, SubscriptionPlansPage, SubscriptionSuccess, SubscriptionCancel, JobPostingPage } from "./pages/jobs";
import AdminJobPostingSettings from "./pages/admin/AdminJobPostingSettings";
import AdminJobsModeration from "./pages/admin/AdminJobsModeration";
import AdminJobServiceTriggers from "./pages/admin/AdminJobServiceTriggers";
import { JobServicePurchaseSuccess } from "./components/services/JobServicePurchase";
import AIAccuracyDashboard from "./pages/admin/AIAccuracyDashboard";
import CandidateBadgesPage from "./pages/CandidateBadgesPage";
import GigSearchPage from "./pages/GigSearchPage";
import AdminTradesServices from "./pages/admin/AdminTradesServices";
import AdminBusinessServices from "./pages/admin/AdminBusinessServices";
import AdminFoodAgriculture from "./pages/admin/AdminFoodAgriculture";
import AdminEducationTuition from "./pages/admin/AdminEducationTuition";
import EducationBookingFlow from "./pages/education/EducationBookingFlow";
import TutorVerificationPage from "./pages/education/TutorVerificationPage";
import TutorProfilePage from "./pages/education/TutorProfilePage";
import TutorRegister from "./pages/education/TutorRegister";
import TutorSearchPage from "./pages/education/TutorSearchPage";
import AdminTutorVerifications from "./pages/admin/AdminTutorVerifications";
import AdminDocumentVerification from "./pages/admin/AdminDocumentVerification";
import AdminLocalization from "./pages/admin/AdminLocalization";
import PetsAdminDashboard from "./pages/admin/PetsAdminDashboard";
import ProviderVerificationDashboard from "./pages/provider/ProviderVerificationDashboard";
import BabyKidsServicesDisplay from "./pages/services/BabyKidsServicesDisplay";
import NewParentStarterKit from "./pages/services/NewParentStarterKit";
import BabyKidsBookingFlow from "./pages/services/BabyKidsBookingFlow";
import BabyKidsCheckout from "./pages/services/BabyKidsCheckout";
import MySavedBundles from "./pages/services/MySavedBundles";
import AdminBabyKids from "./pages/admin/AdminBabyKids";
import PetsAnimalsServicesDisplay from "./pages/services/PetsAnimalsServicesDisplay";
import PetServiceBookingFlow from "./pages/services/PetServiceBookingFlow";
import PetOwnerDashboard from "./pages/services/PetOwnerDashboard";
import MusicalInstrumentsServicesDisplay from "./pages/services/MusicalInstrumentsServicesDisplay";
import MusicServiceBookingFlow from "./pages/services/MusicServiceBookingFlow";
import MusicQuoteRequestFlow from "./pages/services/MusicQuoteRequestFlow";
import AdminMusicalInstruments from "./pages/admin/AdminMusicalInstruments";
import EventsServicesDisplay from "./pages/services/EventsServicesDisplay";
import EventBookingPage from "./pages/services/EventBookingPage";
import EventQuotePage from "./pages/services/EventQuotePage";
import ReportIssuePage from "./pages/services/ReportIssuePage";
import EventProviderDashboard from "./pages/provider/EventProviderDashboard";
import AdminEventsPage from "./pages/admin/AdminEventsPage";
import PaymentSuccessPage from "./pages/services/PaymentSuccessPage";
import PaymentCancelledPage from "./pages/services/PaymentCancelledPage";
import ReviewPage from "./pages/services/ReviewPage";
import EventPackagesPage from "./pages/services/EventPackagesPage";
import LoyaltyProgramPage from "./pages/services/LoyaltyProgramPage";
import CommunityPostForm from "./pages/CommunityPostForm";
import CommunityHub from "./pages/CommunityHub";
import CommunityModerationDashboard from "./pages/admin/CommunityModerationDashboard";
import CommunityContactPage, { CommunityInbox } from "./pages/CommunityMessaging";
import BooksMediaPostForm from "./pages/BooksMediaPostForm";
import BooksMediaListings from "./pages/BooksMediaListings";
import AdminBooksMedia from "./pages/admin/AdminBooksMedia";
import BooksWantedPage from "./pages/BooksWantedPage";
import SellerSubscriptionsPage from "./pages/SellerSubscriptionsPage";
import EscrowPage from "./pages/EscrowPage";
import SellerAnalyticsPage from "./pages/SellerAnalyticsPage";
import PurchaseHistoryPage from "./pages/PurchaseHistoryPage";
import PriceAlertsPage from "./pages/PriceAlertsPage";
import SellerVerificationPage from "./pages/SellerVerificationPage";
import SellerReviewsPage from "./pages/SellerReviewsPage";
import MyQuotesPage from "./pages/MyQuotesPage";
import MyRFQsPage from "./pages/MyRFQsPage";
import QuotesInboxPage from "./pages/QuotesInboxPage";
import BookingDetailsPage from "./pages/BookingDetailsPage";
import RFQProviderDashboard from "./pages/RFQProviderDashboard";
import SubmitQuotePage from "./pages/SubmitQuotePage";
import SavedSearchesPage from "./pages/SavedSearchesPage";
import SharedComparisonPage from "./pages/SharedComparisonPage";
import SavedComparisonsPage from "./pages/SavedComparisonsPage";
import MyAlertsPage from "./pages/MyAlertsPage";
import NotificationPreferences from "./pages/NotificationPreferences";
import AdvertiserOnboarding from "./pages/AdvertiserOnboarding";
import AdvertiserProfilePage from "./pages/AdvertiserProfilePage";
import AdvertiserDashboard from "./pages/AdvertiserDashboard";
import AdminLegalPages from "./pages/admin/AdminLegalPages";
import GetVerified from "./pages/GetVerified";
import AdminVerifications from "./pages/admin/AdminVerifications";
import AdminListingQueue from "./pages/admin/AdminListingQueue";
import AdminReminderAnalytics from "./pages/admin/AdminReminderAnalytics";
import AdminRepeatOffenders from "./pages/admin/AdminRepeatOffenders";
import AdminAlertBell from "./components/AdminAlertBell";
import { Toaster } from "./components/ui/toaster";
import { CountryProvider } from "./context/CountryContext";
import ScrollToTop from "./components/ScrollToTop";

function App() {
  return (
    <CountryProvider>
      <div className="App">
        <BrowserRouter>
          <ScrollToTop />
          <AdminAlertBell />
          <Routes>
            {/* Admin Routes (No Navbar/Footer) */}
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
          <Route path="/admin/staff" element={<StaffManagement />} />
          <Route path="/admin/ads" element={<AdManagement />} />
          <Route path="/admin/categories" element={<CategoryManagement />} />
          <Route path="/admin/memberships" element={<AdminMembershipManagement />} />
          <Route path="/admin/membership-plans" element={<AdminMembershipPlans />} />
          <Route path="/admin/languages" element={<AdminLanguages />} />
          <Route path="/admin/identity-verification" element={<AdminIdentityVerification />} />
          <Route path="/admin/document-verification" element={<AdminDocumentVerification />} />
          <Route path="/admin/verifications" element={<AdminVerifications />} />
          <Route path="/admin/listing-queue" element={<AdminListingQueue />} />
          <Route path="/admin/reminder-analytics" element={<AdminReminderAnalytics />} />
          <Route path="/admin/repeat-offenders" element={<AdminRepeatOffenders />} />
          <Route path="/admin/localization" element={<AdminLocalization />} />
          <Route path="/admin/legal" element={<AdminLegalPages />} />
          <Route path="/admin/roles" element={<AdminRolesManagement />} />
          <Route path="/admin/2fa-settings" element={<Admin2FASettings />} />
          <Route path="/admin/ads/auto-approval" element={<AutoApprovalRules />} />
          <Route path="/admin/ads/banners" element={<BannerAdsManagement />} />
          <Route path="/admin/ads/analytics" element={<AdAnalyticsDashboard />} />
          
          {/* Lender Portal Routes (No Navbar/Footer) */}
          <Route path="/lender/register" element={<LenderRegister />} />
          <Route path="/lender/login" element={<LenderLogin />} />
          <Route path="/lender/dashboard" element={<LenderDashboard />} />
          
          {/* Insurer Portal Routes (No Navbar/Footer) */}
          <Route path="/insurer/register" element={<InsurerRegister />} />
          <Route path="/insurer/login" element={<InsurerLogin />} />
          <Route path="/insurer/dashboard" element={<InsurerDashboard />} />
          
          {/* Service Provider Portal Routes (No Navbar/Footer) */}
          <Route path="/provider/register" element={<ProviderRegister />} />
          <Route path="/provider/login" element={<ProviderLogin />} />
          <Route path="/provider/dashboard" element={<ProviderDashboard />} />
          <Route path="/provider/rfq-dashboard" element={<RFQProviderDashboard />} />
          <Route path="/provider/submit-quote/:rfqId" element={<SubmitQuotePage />} />

          {/* Coach Portal Routes */}
          <Route path="/coach/register" element={<CoachRegister />} />
          <Route path="/coach/dashboard" element={<CoachDashboard />} />
          
          {/* Main Site Routes (With Navbar/Footer) */}
          <Route path="*" element={
            <>
              <Navbar />
              <VerifyPhoneBanner />
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/login" element={<Login />} />
                <Route path="/register" element={<SignupWizard />} />
                <Route path="/register-legacy" element={<Register />} />
                <Route path="/forgot-password" element={<ForgotPassword />} />
                <Route path="/category/:slug" element={<CategoryPage />} />
                <Route path="/search" element={<SearchResults />} />
                <Route path="/listing/:id" element={<ListingDetail />} />
                <Route path="/jobs" element={<JobsPage />} />
                <Route path="/jobs/:jobId" element={<JobDetailPage />} />
                <Route path="/jobs/dashboard" element={<CandidateDashboard />} />
                <Route path="/jobs/employer-dashboard" element={<EmployerDashboard />} />
                <Route path="/employer" element={<EmployerDashboardAI />} />
                <Route path="/employer/post" element={<EmployerDashboardAI />} />
                <Route path="/jobs/subscription" element={<SubscriptionPlansPage />} />
                <Route path="/jobs/employer-subscription" element={<SubscriptionPlansPage />} />
                <Route path="/jobs/subscription/success" element={<SubscriptionSuccess />} />
                <Route path="/jobs/subscription/cancel" element={<SubscriptionCancel />} />
                <Route path="/jobs/post" element={<JobPostingPage />} />
                <Route path="/admin/job-posting" element={<AdminJobPostingSettings />} />
                <Route path="/admin/healthcare-moderation" element={<AdminJobsModeration />} />
                <Route path="/admin/jobs-moderation" element={<AdminJobsModeration />} />
                <Route path="/admin/job-triggers" element={<AdminJobServiceTriggers />} />
                <Route path="/admin/ai-accuracy" element={<AIAccuracyDashboard />} />
                <Route path="/job-services/success" element={<JobServicePurchaseSuccess />} />
                <Route path="/job-services/cancel" element={<JobsPage />} />
                <Route path="/candidate-badges" element={<CandidateBadgesPage />} />
                <Route path="/gigs" element={<GigSearchPage />} />
                <Route path="/freelance" element={<GigSearchPage />} />
                <Route path="/post-ad" element={<AIAdAssistant />} />
                <Route path="/edit-ad/:id" element={<EditAd />} />
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/favorites" element={<Favorites />} />
                <Route path="/saved-searches" element={<SavedSearches />} />
                <Route path="/verification" element={<VerificationPage />} />
                <Route path="/get-verified" element={<GetVerified />} />
                <Route path="/my-orders" element={<MyOrders />} />
                <Route path="/identity-verification" element={<IdentityVerification />} />
                <Route path="/security/2fa" element={<TwoFactorSetup />} />
                <Route path="/privacy" element={<PrivacyPolicy />} />
                <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                <Route path="/disclaimer" element={<Disclaimer />} />
                <Route path="/terms" element={<TermsOfService />} />
                <Route path="/terms-of-service" element={<TermsOfService />} />
                <Route path="/help" element={<HelpCentre />} />
                <Route path="/help-centre" element={<HelpCentre />} />
                <Route path="/membership" element={<Membership />} />
                <Route path="/membership/success" element={<MembershipSuccess />} />
                <Route path="/boost" element={<BoostOptimizer />} />
                <Route path="/boost/success" element={<BoostSuccess />} />
                <Route path="/boost/cancel" element={<BoostOptimizer />} />
                <Route path="/messages" element={<ChatPage />} />
                <Route path="/messages/:conversationId" element={<ChatPage />} />
                <Route path="/analytics" element={<UserAnalytics />} />
                <Route path="/admin/ai-monitoring" element={<AIMonitoringDashboard />} />
                <Route path="/admin/ai-control" element={<AdminAIControlCenter />} />
                <Route path="/admin/content-moderation" element={<ContentModerationQueue />} />
                <Route path="/admin/otp-settings" element={<OTPAdminSettings />} />
                <Route path="/admin/vehicles" element={<AdminVehiclesDashboard />} />
                <Route path="/admin/vehicles/config" element={<VehicleConfigPage />} />
                <Route path="/admin/vehicles/ranking" element={<VehicleRankingPage />} />
                <Route path="/admin/vehicles/governance" element={<ListingsGovernancePage />} />
                <Route path="/admin/vehicles/moderation" element={<ModerationQueuePage />} />
                <Route path="/admin/vehicles/data" element={<DataEnrichmentPage />} />
                <Route path="/admin/vehicles/data/makes" element={<MakeModelManagementPage />} />
                <Route path="/admin/vehicles/listing-tabs" element={<ListingTabsManagementPage />} />
                <Route path="/admin/vehicles/partners" element={<PartnersServicesPage />} />
                <Route path="/admin/vehicles/presets" element={<AIPresetsManagementPage />} />
                <Route path="/admin/finance" element={<FinanceAdminDashboard />} />
                <Route path="/admin/insurance" element={<InsuranceAdminDashboard />} />
                <Route path="/admin/marketplace" element={<MarketplaceDashboard />} />
                <Route path="/admin/services" element={<ServicesAdminDashboard />} />
                <Route path="/admin/service-analytics" element={<ServiceAnalyticsDashboard />} />
                <Route path="/admin/badge-analytics" element={<AdminBadgeAnalytics />} />
                <Route path="/admin/it-services" element={<AdminITServices />} />
                <Route path="/admin/trades-services" element={<AdminTradesServices />} />
                <Route path="/admin/business-services" element={<AdminBusinessServices />} />
                <Route path="/admin/food-agriculture" element={<AdminFoodAgriculture />} />
                <Route path="/admin/education-tuition" element={<AdminEducationTuition />} />
                <Route path="/admin/tutor-verifications" element={<AdminTutorVerifications />} />
                <Route path="/admin/baby-kids" element={<AdminBabyKids />} />
                <Route path="/admin/pets" element={<PetsAdminDashboard />} />
                <Route path="/provider/verification" element={<ProviderVerificationDashboard />} />
                <Route path="/book/education/:tutorId" element={<EducationBookingFlow />} />
                <Route path="/tutor/register" element={<TutorRegister />} />
                <Route path="/tutor/search" element={<TutorSearchPage />} />
                <Route path="/find-tutor" element={<TutorSearchPage />} />
                <Route path="/tutor/:tutorId/verification" element={<TutorVerificationPage />} />
                <Route path="/tutor/:tutorId" element={<TutorProfilePage />} />
                <Route path="/baby-kids" element={<BabyKidsServicesDisplay />} />
                <Route path="/category/baby-kids" element={<BabyKidsServicesDisplay />} />
                <Route path="/baby-kids/starter-kit" element={<NewParentStarterKit />} />
                <Route path="/new-parent-starter-kit" element={<NewParentStarterKit />} />
                <Route path="/new-parent-starter-kit/:shareToken" element={<NewParentStarterKit />} />
                <Route path="/baby-kids/booking/:listingId" element={<BabyKidsBookingFlow />} />
                <Route path="/baby-kids/booking" element={<BabyKidsBookingFlow />} />
                <Route path="/baby-kids/checkout" element={<BabyKidsCheckout />} />
                <Route path="/my-saved-bundles" element={<MySavedBundles />} />
                {/* Pets & Animals Routes */}
                <Route path="/pets" element={<PetsAnimalsServicesDisplay />} />
                <Route path="/pets-animals" element={<PetsAnimalsServicesDisplay />} />
                <Route path="/category/pets-animals" element={<PetsAnimalsServicesDisplay />} />
                <Route path="/pets/book/:providerId" element={<PetServiceBookingFlow />} />
                <Route path="/pets/book" element={<PetServiceBookingFlow />} />
                <Route path="/pets/dashboard" element={<PetOwnerDashboard />} />
                <Route path="/my-pets" element={<PetOwnerDashboard />} />
                
                {/* Musical Instruments Routes */}
                <Route path="/music" element={<MusicalInstrumentsServicesDisplay />} />
                <Route path="/musical-instruments" element={<MusicalInstrumentsServicesDisplay />} />
                <Route path="/category/musical-instruments" element={<MusicalInstrumentsServicesDisplay />} />
                <Route path="/music/book/:providerId" element={<MusicServiceBookingFlow />} />
                <Route path="/music/book" element={<MusicServiceBookingFlow />} />
                <Route path="/music/quote" element={<MusicQuoteRequestFlow />} />
                <Route path="/music/quote/:type" element={<MusicQuoteRequestFlow />} />
                <Route path="/admin/musical-instruments" element={<AdminMusicalInstruments />} />
                <Route path="/my-quotes" element={<MyQuotesPage />} />
                
                {/* Events & Functions Routes */}
                <Route path="/events" element={<EventsServicesDisplay />} />
                <Route path="/events-functions" element={<EventsServicesDisplay />} />
                <Route path="/category/events-functions" element={<EventsServicesDisplay />} />
                <Route path="/events/book/:providerId" element={<EventBookingPage />} />
                <Route path="/events/quote/:providerId" element={<EventQuotePage />} />
                <Route path="/events/report-issue" element={<ReportIssuePage />} />
                <Route path="/events/report-issue/:bookingId" element={<ReportIssuePage />} />
                <Route path="/events/provider-dashboard" element={<EventProviderDashboard />} />
                <Route path="/events/payment-success" element={<PaymentSuccessPage />} />
                <Route path="/events/payment-cancelled" element={<PaymentCancelledPage />} />
                <Route path="/events/review/:bookingId" element={<ReviewPage />} />
                <Route path="/events/packages" element={<EventPackagesPage />} />
                <Route path="/events/loyalty" element={<LoyaltyProgramPage />} />
                <Route path="/loyalty" element={<LoyaltyProgramPage />} />
                <Route path="/admin/events" element={<AdminEventsPage />} />
                
                {/* Community Routes */}
                <Route path="/community" element={<CommunityHub />} />
                <Route path="/community/post" element={<CommunityPostForm />} />
                <Route path="/community/contact/:postId" element={<CommunityContactPage />} />
                <Route path="/admin/community" element={<CommunityModerationDashboard />} />
                
                {/* Books & Media Routes */}
                <Route path="/books-media" element={<BooksMediaListings />} />
                <Route path="/category/books-media" element={<BooksMediaListings />} />
                <Route path="/books-media/post" element={<BooksMediaPostForm />} />
                <Route path="/books-media/post/:category" element={<BooksMediaPostForm />} />
                <Route path="/books-media/wanted" element={<BooksWantedPage />} />
                <Route path="/books-media/subscriptions" element={<SellerSubscriptionsPage />} />
                <Route path="/books-media/escrow/:escrowId" element={<EscrowPage />} />
                <Route path="/books-media/analytics" element={<SellerAnalyticsPage />} />
                <Route path="/books-media/purchases" element={<PurchaseHistoryPage />} />
                <Route path="/books-media/price-alerts" element={<PriceAlertsPage />} />
                <Route path="/books-media/verification" element={<SellerVerificationPage />} />
                <Route path="/books-media/reviews" element={<SellerReviewsPage />} />
                <Route path="/admin/books-media" element={<AdminBooksMedia />} />
                
                {/* Property Saved Searches */}
                <Route path="/my-saved-searches" element={<SavedSearchesPage />} />
                
                {/* Shared Property Comparison */}
                <Route path="/compare/:shareId" element={<SharedComparisonPage />} />
                
                {/* Saved Property Comparisons */}
                <Route path="/my-comparisons" element={<SavedComparisonsPage />} />
                
                {/* Price Alerts */}
                <Route path="/my-alerts" element={<MyAlertsPage />} />
                
                {/* Notification Preferences */}
                <Route path="/notification-preferences" element={<NotificationPreferences />} />
                
                {/* Advertiser Routes */}
                <Route path="/advertiser/register" element={<AdvertiserOnboarding />} />
                <Route path="/advertiser/dashboard" element={<AdvertiserDashboard />} />
                <Route path="/advertiser/:advertiserId" element={<AdvertiserProfilePage />} />
                
                <Route path="/admin/settings" element={<AdminSettings />} />
                <Route path="/admin/payments" element={<PaymentVerificationDashboard />} />
                <Route path="/my-rfqs" element={<MyRFQsPage />} />
                <Route path="/rfq/:rfqId/quotes" element={<QuotesInboxPage />} />
                <Route path="/bookings/:bookingId" element={<BookingDetailsPage />} />
                <Route path="/profile/:userId" element={<UserProfile />} />
                <Route path="/payment/select-method" element={<PaymentMethodSelection />} />
                <Route path="/payment/bank-transfer" element={<BankTransferPayment />} />
                <Route path="/payment/upload-proof" element={<UploadPaymentProof />} />
                <Route path="/payment/status" element={<PaymentStatus />} />
                <Route path="/payment/success" element={<PaymentSuccess />} />
                <Route path="/payment/rejected" element={<PaymentRejected />} />
                <Route path="/feature-ad" element={<FeatureAdPurchase />} />
                <Route path="/admin/payment-verification" element={<AdminPaymentVerification />} />
                <Route path="/feedback/:token" element={<FeedbackPage />} />
                <Route path="/delivery-services" element={<DeliveryServicesPage />} />
                <Route path="/services/:category" element={<ServiceListingPage />} />
              </Routes>
              <TopLocations />
              <Footer />
            </>
          } />
        </Routes>
        <Toaster />
      </BrowserRouter>
    </div>
    </CountryProvider>
  );
}

export default App;